import { render, staticRenderFns } from "./store-domains.vue?vue&type=template&id=a77d78d0&"
import script from "./store-domains.vue?vue&type=script&lang=js&"
export * from "./store-domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports